export const handleVerify = (valuesProps) => {
  const validGroupIds = new Set([1, 8, 6]);
  const validDescriptions = new Set([
    18,
    19,
    21,
    24,
    28,
    30,
    32,
    37,
  ]);

  const groupId = valuesProps?.tipoAnexo?.grupo?.id;
  const descricao = valuesProps?.tipoAnexo?.id;

  if (validGroupIds.has(groupId) || validDescriptions.has(descricao)) {
    return true;
  }

  return false;
};
